import { Box, Divider, Grid, Paper, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import RequiredLabel from "components/RequiredLabel";
import dayjs from "dayjs";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function PriorSchool() {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Box>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
        <Box
          backgroundColor="divider"
          sx={{ p: 2, borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
        >
          <Typography variant="h6">{t("Previous School (Most Recent)")}</Typography>
        </Box>
        <Divider sx={{ mb: 1 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Controller
              name="schoolName"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={<RequiredLabel>{t("School Name")}</RequiredLabel>}
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message || t("If this is your child’s first year in school, write “First Year.”")}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="district"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={t("District")}
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <Controller
              name="schoolAddress"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={t("School Address")}
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="schoolPhone"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={t("School Phone")}
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="usSchoolEntryDate"
              control={control}
              render={({ field: { onChange, value, ...rest }, fieldState }) => (
                <DatePicker
                  {...rest}
                  label={t("US School Entry Date")}
                  value={
                    value ? (dayjs.isDayjs(value) ? value : dayjs(value)) : null
                  }
                  onChange={(newValue) => {
                    const date = newValue && newValue.isValid() ? newValue.toDate() : null;
                    onChange(date);
                  }}
                  slotProps={{
                    textField: {
                      error: !!fieldState.error,
                      helperText:
                        fieldState.error?.message ||
                        t("US School Entry Date = the date your child first entered a school in the United States."),
                      fullWidth: true,
                    },
                    actionBar: {
                      actions: ['clear', 'accept'],
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
